@import "../../utils/error-message.css";

:host {
  display: block;
  font-family: var(--ls-font-family);
  position: relative;
  /* Large default keeps layout single-column unless explicitly overridden. */
  --ls-status-grid-breakpoint: 9999px;
}

.content {
  position: relative;
  display: grid;
  gap: var(--ls-status-grid-gap, 2rem);
  padding-inline: var(
    --ls-status-grid-padding-x,
    0
  );
  padding-bottom: var(
    --ls-status-grid-padding-bottom,
    0
  );
  font-size: var(--text-sm, var(--ls-text-sm));
  line-height: var(--text-sm--line-height, var(--ls-line-sm));
  grid-template-columns: 1fr;
}

.content.two-columns {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.content.two-columns > ls-status-item:last-child:nth-child(odd) {
  grid-column: 1 / -1;
}
